
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eSwarna-digital-gold",
      function () {
        return require("private-next-pages/eSwarna-digital-gold/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/eSwarna-digital-gold"])
      });
    }
  